import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from '../utils/functions';

const $postListEl = $('.post-list');

$(function () {
    if ($postListEl.length > 0) {
        $postListEl.each(function () {
            postList($(this));
        });
    }
});

const postList = (listEl) => {
    const filter = {
        page: 1,
        limit: listEl.data('limit'),
        categories: listEl.data('categories'),
        category: '',
        search: '',
        year: '',
        lang: listEl.data('lang'),
    };

    bindPagination(listEl, filter);
    bindPostFilter(listEl, filter);
};

const reRenderList = async (element, filter, scrollTop = false) => {
    const data = await getPosts(filter);
    element.find('.post-list__content').html(data.html);

    if (scrollTop === true) {
        smoothscroll(element, 'header');
    }
};

const bindPagination = (element, filter) => {
    element.on('click', '.pagination__item', function () {
        filter.page = $(this).data('page');
        reRenderList(element, filter, true);
    });
};

const bindPostFilter = (element, filter) => {
    element.on('click', '.post-filter__item', function () {
        const $thisEl = $(this);
        $('.post-filter__item.selected').removeClass('selected');
        $thisEl.addClass('selected');

        filter.page = 1;
        filter.category = $thisEl.data('id');
        reRenderList(element, filter);
    });

    element.on(
        'input',
        "input[name='post-filter-input-search']",
        debounce(function () {
            const $input = $(this);
            filter.page = 1;
            filter.search = $input.val();

            if (filter.search) {
                $input.parent().addClass('has-value');
            } else {
                $input.parent().removeClass('has-value');
            }

            reRenderList(element, filter);
        })
    );

    element.on('click', "button[name='post-filter-input-reset']", function () {
        element.find("input[name='post-filter-input-search']").val('').trigger('input');
    });
};

const getPosts = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/nitra/v1/post-list/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
